/**
 * PlayerBottomNav — extracted from PlayerApp.jsx (Iter 140 refactor).
 *
 * The fixed bottom navigation with sliding active-tab pill indicator and
 * pressable tab buttons. Pure presentational — all state owned by the
 * parent. No logic changes from the inlined version; this is a pure
 * extract for code-organization.
 */
import { memo } from 'react';

function PlayerBottomNav({
  tabs,
  activeTab,
  onSwitch,
  chatUnread = 0,
}) {
  return (
    <nav
      className="vl-bottom-nav flex-shrink-0 z-50"
      data-testid="player-bottom-nav"
      aria-label="Player dock"
    >
      <div className="vl-bottom-nav__frame">
        <span className="vl-bottom-nav__rope" aria-hidden="true" />
        <span className="vl-bottom-nav__bow" aria-hidden="true" />
        <div className="vl-bottom-nav__inner">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => onSwitch(tab.id)}
                className="vl-dock-item"
                data-testid={`tab-${tab.id}`}
                data-active={isActive ? 'true' : 'false'}
              >
                <span className="vl-dock-item__medallion">
                  <span className="vl-dock-item__wheel" aria-hidden="true" />
                  <Icon />
                  <i aria-hidden="true" />
                </span>
                <span className="vl-dock-item__label">{tab.label}</span>
                <span className="vl-dock-item__rivet" aria-hidden="true" />
                {tab.id === 'chat' && chatUnread > 0 && !isActive && (
                  <span className="vl-dock-item__badge" data-testid="chat-badge">
                    {chatUnread > 9 ? '9+' : chatUnread}
                  </span>
                )}
              </button>
            );
          })}
        </div>
        <span className="vl-bottom-nav__wake" aria-hidden="true" />
        <span className="vl-bottom-nav__keel" aria-hidden="true" />
      </div>
    </nav>
  );
}

export default memo(PlayerBottomNav);
